var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.$route.meta.independente)?_c('core-template-default',{style:(`
--theme-primary: ${_vm.$vuetify.theme.themes.light.primary};
--theme-secondary: ${_vm.$vuetify.theme.themes.light.secondary};
--theme-tertiary: ${_vm.$vuetify.theme.themes.light.tertiary};
`)}):_c('v-app',{style:(`
--theme-primary: ${_vm.$vuetify.theme.themes.light.primary};
--theme-secondary: ${_vm.$vuetify.theme.themes.light.secondary};
--theme-tertiary: ${_vm.$vuetify.theme.themes.light.tertiary};
`)},[_c('notificacao'),_c('loading'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }